import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { LoginServiceService } from 'src/app/services/api/login-service.service';
import { SnackBarService } from 'src/app/services/SharedServices/snack-bar.service';
import { environment } from 'src/environments/environment';



const passwordvalidator: ValidatorFn = (fg: FormGroup) => {
  const password = fg.get('password').value;
  const confirmpassword = fg.get('confirmpassword').value;
  return password !== null && confirmpassword !== null && password === confirmpassword
    ? null
    : { value: true };
};
@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

  constructor(private router: Router,private _loginService : LoginServiceService,private route: ActivatedRoute,private _snackbarService : SnackBarService) { }

  username: string;
  password: string;
  Checked : boolean = false;
  RememberMe : boolean = false;
  token: string;
  errorMessage = '';
  passwordType = 'password';
  loginForm = new FormGroup({
    password: new FormControl('', [Validators.required]),   
     confirmpassword : new FormControl('', [Validators.required]),
  }, [passwordvalidator]  );
  ngOnInit( ): void {
  //   console.log( this.router.url);
  //   var a = this.router.url;
  //  console.log(a.substring(a.search("?"),a.length-1)) ;
  this.route.queryParams
      .subscribe(params => {
        console.log(params); // { token: "fiction" }
        this.token = params.token;
        this.username = params.username;
        console.log(this.token); // fiction
      }
    );
  

  }
  setPasswordType(): void {
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
  }
  resetPassword(e) {
    console.log(e);
    var resetobj = {
      password : e.password,
      token : this.token,
      
      username : this.username
    }
    this._loginService.ResetPassword(resetobj).subscribe((res) => {
        console.log(res);
        const options = {
          title: 'Succesful',
          message: 'Your password is reset.',
          cancelText: 'Ok',
          //confirmText: 'Confirm'
        };
        this._snackbarService.open(options);
    },
    (err) => {
      console.log(err);
      const options = {
        title: 'Failed',
        message: 'Failed,Please try again',
        cancelText: 'Ok',
        //confirmText: 'Confirm'
      };
      this._snackbarService.open(options);    })
  }

}
